module.exports = __webpack_public_path__ + "assets/effects-btn-icon.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icons/effects-btn-icon.svg
// module id = 808
// module chunks = 0